import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["__scopeDialog"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { CLOSE_NAME } from './constants';
import { useDialogContext } from './context';
import { DomPrimitive } from '../../internal/components/DomPrimitive';
import { composeEventHandlers } from '../../internal/utils/composeEventHandlers';
import { jsx as _jsx } from "react/jsx-runtime";
export var DialogClose = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var __scopeDialog = props.__scopeDialog,
    closeProps = _objectWithoutProperties(props, _excluded);
  var context = useDialogContext(CLOSE_NAME, __scopeDialog);
  return /*#__PURE__*/_jsx(DomPrimitive.button, _objectSpread(_objectSpread({
    type: "button"
  }, closeProps), {}, {
    ref: forwardedRef,
    onClick: composeEventHandlers(props.onClick, function () {
      return context.onOpenChange(false);
    })
  }));
});
DialogClose.displayName = CLOSE_NAME;